module.exports = __webpack_public_path__ + "static/media/privacy.d998db2f.svg";